import React from 'react';
import { useTranslation } from 'react-i18next';
import { ListItemLink } from '@wix/da-ds/pkg/List/ListItem';
const GoToTier = ({ deviation })=>{
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement(ListItemLink, {
        label: t('deviationview.tierCard.moreActionsMenu.item.goToTierPage'),
        href: deviation.url
    });
};
GoToTier.displayName = 'GoToTier';
export default GoToTier;
